export default function flattenArray<T>(array: Array<T>): Array<T> {
  return array.reduce((acc: Array<T>, val: T) => acc.concat(val), []);
}
